export enum MiniMapPosition {
  UpperLeft = 'UpperLeft',
  UpperRight = 'UpperRight'
}
